.summary-wrapper {
  display: flex;
  flex-direction: row;
  justify-content: space-evenly;
}

.datum {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;

  .datum-title {
    font-size: 16px;
  }

  .datum-value {
    font-size: 32px;
  }
}
